module.exports = __webpack_public_path__ + "img/pingan_success_bg.44466c07.jpg";